import styled from 'styled-components'
import { Modal } from '@velasca/ui/modal'

export const StyledModal = styled(Modal)`
  background-color: ${({ theme }) => theme.colors.modalBackground ?? ''};
`

export const Content = styled.div`
  overflow-y: auto;
  justify-content: center;
  width: 95vw;
  max-height: 95vh;
  max-height: 95dvh;
  padding: 3rem 1rem;

  @media screen and (min-width: 425px) {
    padding: 3rem;
  }

  @media screen and (min-width: 525px) {
    padding: 2rem 6rem;
  }

  @media screen and (min-width: 768px) {
    max-height: 90vh;
    max-height: 90dvh;
    padding: 4rem 8rem;
    max-width: 80rem;
  }
`
